import './TopNavigation.scss';
import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { DatasetsUploadDropdownContainer } from '../../__legacy__/containers/DatasetsUploadDropdown.container';
import { UserDropdownContainer } from '../../__legacy__/containers/UserDropdown.container';
import { AttachmentUploadDropdownContainer } from '../../__legacy__/modules/attachments/containers/AttachmentUploadDropdown.container';
import { Limit } from '../../__legacy__/modules/billing/components/Limit';
import { NotificationsHubContainer } from '../../__legacy__/modules/notifications/containers/NotificationsHub.container';
import { CurrentWorkspaceRole } from '../../__legacy__/modules/workspaces/components/CurrentWorkspaceRole';
import { UnlockWorkspaceModal } from '../../__legacy__/modules/workspaces/components/UnlockWorkspaceModal';
import { CreateWorkspaceContainer } from '../../__legacy__/modules/workspaces/containers/CreateWorkspace.container';
import { CurrentWorkspaceContainer } from '../../__legacy__/modules/workspaces/containers/CurrentWorkspace.container';
import { GoToWorkspacesButtonContainer } from '../../__legacy__/modules/workspaces/containers/GoToWorkspacesButtonContainer';
import { MoreOptionsWorkspaceContainer } from '../../__legacy__/modules/workspaces/containers/MoreOptionsWorkspace.container';
import { ZebraTopLogo } from '../../design/static/logos/ZebraTopLogo';
import { RowLayout } from '../common/layouts/rowLayout/RowLayout';
import { CurrentWorkspaceSelectorContainer } from '../workspaces/currentWorkspace/ui/selector/CurrentWorkspaceSelector.container';

export const TopNavigation = (): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='top-navigation'>
      <a
        className='top-navigation-logo-with-name'
        href='/'
      >
        <ZebraTopLogo className='top-navigation-logo' />
        <div className='aurora-cloud-training-header'>{t('app_name')}</div>
      </a>
      <CurrentWorkspaceContainer>
        {(unlockWorkspaceModal, currentWorkspaceRoleProps): ReactElement => (
          <>
            <CurrentWorkspaceSelectorContainer />
            <UnlockWorkspaceModal {...unlockWorkspaceModal} />
            <RowLayout size='none'>
              <MoreOptionsWorkspaceContainer />
              <CreateWorkspaceContainer />
              <GoToWorkspacesButtonContainer />
            </RowLayout>
            <RowLayout size='md'>
              <CurrentWorkspaceRole {...currentWorkspaceRoleProps} />
            </RowLayout>
          </>
        )}
      </CurrentWorkspaceContainer>
      <div className='top-navigation-right-side'>
        <Limit />
        <AttachmentUploadDropdownContainer />
        <DatasetsUploadDropdownContainer />
        <NotificationsHubContainer />
        <UserDropdownContainer />
      </div>
    </div>
  );
};
